import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiFolderPlus, FiUsers, FiMessageSquare, FiCalendar, FiAward, FiArrowRight } from 'react-icons/fi';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

const StatCard = ({ icon, label, count, color, to }) => (
  <Link to={to} style={{ textDecoration:'none' }}>
    <div style={{ background:'white', borderRadius:'16px', padding:'1.5rem', display:'flex', alignItems:'center', gap:'1rem', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:'1px solid #F3F4F6', transition:'all 0.2s', cursor:'pointer' }}
      onMouseEnter={e=>{ e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,0.1)'; }}
      onMouseLeave={e=>{ e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='0 1px 4px rgba(0,0,0,0.06)'; }}>
      <div style={{ width:50, height:50, borderRadius:'12px', background:color, display:'flex', alignItems:'center', justifyContent:'center', color:'white', fontSize:'1.2rem', flexShrink:0 }}>{icon}</div>
      <div style={{ flex:1 }}>
        <div style={{ fontFamily:'Fraunces,serif', fontSize:'1.9rem', fontWeight:700, color:'var(--navy)', lineHeight:1 }}>{count}</div>
        <div style={{ color:'var(--gray-400)', fontSize:'0.82rem', marginTop:'0.2rem' }}>{label}</div>
      </div>
      <FiArrowRight style={{ color:'var(--gray-300)', fontSize:'0.9rem' }} />
    </div>
  </Link>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState({ projects:0, team:0, testimonials:0, bookings:0, certificates:0, pendingTest:0, pendingBook:0 });

  useEffect(() => {
    Promise.all([api.get('/projects/admin/all'), api.get('/team'), api.get('/testimonials/admin/all'), api.get('/bookings'), api.get('/certificates')])
      .then(([proj, team, test, book, cert]) => setStats({
        projects: proj.data.length, team: team.data.length,
        testimonials: test.data.length, bookings: book.data.length, certificates: cert.data.length,
        pendingTest: test.data.filter(t=>t.status==='pending').length,
        pendingBook: book.data.filter(b=>b.status==='pending').length,
      })).catch(()=>{});
  }, []);

  return (
    <AdminLayout title="Dashboard">
      <div style={{ maxWidth:1000 }}>
        <p style={{ color:'var(--gray-400)', marginBottom:'2rem', fontSize:'0.9rem' }}>Welcome back! Here's an overview of your website activity.</p>
        <div className="grid-3" style={{ marginBottom:'2rem' }}>
          <StatCard icon={<FiFolderPlus />} label="Total Projects" count={stats.projects} color="#0B2545" to="/admin/projects" />
          <StatCard icon={<FiUsers />} label="Team Members" count={stats.team} color="#1e40af" to="/admin/team" />
          <StatCard icon={<FiAward />} label="Certificates" count={stats.certificates} color="#065f46" to="/admin/certificates" />
          <StatCard icon={<FiCalendar />} label="Total Bookings" count={stats.bookings} color="#92400e" to="/admin/bookings" />
          <StatCard icon={<FiMessageSquare />} label="Testimonials" count={stats.testimonials} color="#5b21b6" to="/admin/testimonials" />
        </div>
        {(stats.pendingTest > 0 || stats.pendingBook > 0) && (
          <div>
            <h3 style={{ color:'var(--navy)', marginBottom:'1rem', fontSize:'0.95rem', fontFamily:'Fraunces,serif' }}>Action Required</h3>
            <div style={{ display:'flex', flexDirection:'column', gap:'0.75rem' }}>
              {stats.pendingTest > 0 && (
                <Link to="/admin/testimonials" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:'#FFFBEB', border:'1px solid #FCD34D', borderRadius:'12px', padding:'1rem 1.25rem', color:'#92400E', textDecoration:'none' }}>
                  <span style={{ fontSize:'0.9rem' }}>⚠️ <strong>{stats.pendingTest}</strong> testimonial{stats.pendingTest>1?'s':''} awaiting review</span>
                  <FiArrowRight style={{ fontSize:'0.85rem' }} />
                </Link>
              )}
              {stats.pendingBook > 0 && (
                <Link to="/admin/bookings" style={{ display:'flex', alignItems:'center', justifyContent:'space-between', background:'#EFF6FF', border:'1px solid #93C5FD', borderRadius:'12px', padding:'1rem 1.25rem', color:'#1E3A8A', textDecoration:'none' }}>
                  <span style={{ fontSize:'0.9rem' }}>📅 <strong>{stats.pendingBook}</strong> booking{stats.pendingBook>1?'s':''} pending confirmation</span>
                  <FiArrowRight style={{ fontSize:'0.85rem' }} />
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
